import type { RouteConfig } from "@/router/types";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

const SubventionsPage = lazyWithRetry(() =>
  import("@/features/subventions/pages/SubventionsPage").then((m) => ({ default: m.SubventionsPage })),
);

export const SUBVENTIONS_PATH = "/subventions";

const subventionsRoutes: RouteConfig[] = [
  {
    path: SUBVENTIONS_PATH,
    element: <SubventionsPage />,
    isProtected: true,
    useMainLayout: true,
  },
];

export default subventionsRoutes;
